<template >
  <section class="instructions">
    <div v-for="instruction in instructions" class="instructions__instruction">
      <div
        class="instructions__img-wrapper"
        :style="{backgroundImage: `url(${getImg(instruction.image)})`}"
      ></div>
      <paragraph :paragraph="instruction.text" />
    </div>
  </section>
</template>

<script >
import titleData from "@/assets/json-data/twelveByOneData";
import Paragraph from "@/components/twelve-by-one-specific-components/Paragraphs";
export default {
  name: "instructions",
  components: {
    Paragraph
  },
  props: [],
  mounted() {},
  data() {
    return {
      instructions: titleData.instructions
    };
  },
  methods: {
    getImg(pic) {
      if (pic) {
        var image = require.context("@/assets/twelve-by-one-assets/", false);
        return image("./" + pic);
      }
    }
  },
  computed: {}
};
</script>

<style scoped lang="scss">
.instructions {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: center;
  align-items: center;

  &__instruction {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    width: 300px;
    text-align: center;
    &:last-of-type {
      margin-left: 100px;
    }
  }
  &__img-wrapper {
    width: 75px;
    height: 75px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    margin-bottom: 25px;
  }
}
</style>
